import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {AsyncStatusesEnum} from '../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {LocalApplicationEntryPointModel} from '../../../../models/api/localApplicationEntryPointModel';
import {LocalApplicationModel} from '../../../../models/api/localApplicationModel';
import {SettingsDevelopersDeleteEntryPointDialog} from '../../dialog/settingsDevelopersDeleteEntryPointDialog';

/*
 * Props.
 */

interface DevelopersHeaderInboxSidePanelEntryPointActionProps {
  application?: LocalApplicationModel;
  entryPoint?: LocalApplicationEntryPointModel;
  entryPointAsyncStatus?: AsyncStatusesEnum;
}

/*
 * Component.
 */

export const DevelopersHeaderInboxSidePanelEntryPointAction: FC<
  DevelopersHeaderInboxSidePanelEntryPointActionProps
> = (props) => {
  const {entryPoint, application, entryPointAsyncStatus} = props;
  const [isShowingDeleteDialog, setIsShowingDeleteDialog] = useState(false);

  // Do not render actions when loading or when we do not have an entry point.
  if (!application || entryPointAsyncStatus === AsyncStatusesEnum.LOADING || !entryPoint) {
    return null;
  }
  return (
    <>
      <Button variant={ButtonVariantsEnum.SECONDARY_DANGER} onClick={() => setIsShowingDeleteDialog(true)}>
        <Trans id="settings-developers-delete-entry-point-action-button">Delete</Trans>
      </Button>
      {isShowingDeleteDialog && (
        <SettingsDevelopersDeleteEntryPointDialog
          onRequestClose={() => setIsShowingDeleteDialog(false)}
          entryPoint={entryPoint}
          application={application}
        />
      )}
    </>
  );
};
